/**
 * vue-sparklines v2.0.1
 * (c) 2022 tangzhen@me.com
 * @license MIT
 */

var defaultLineStyle = {
  stroke: "slategray",
  strokeWidth: 1,
  strokeLinejoin: "round",
  strokeLinecap: "round",
  fill: "none"
};
var defaultFillStyle = {
  stroke: "none",
  strokeWidth: 0,
  fillOpacity: 0.1,
  fill: "none"
};
var defaultTooltipStyle = {
  display: "none",
  background: "rgba(0, 0, 0, 0.6)",
  borderRadius: "3px",
  minWidth: "30px",
  padding: "3px",
  color: "#fff",
  fontSize: "12px"
};
var defaultSpotProps = {
  size: 3,
  spotColors: {
    "-1": "#dd2c00",
    "0": "#ffab00",
    "1": "#00c853"
  }
};
var refLineTypes = ["max", "min", "mean", "avg", "median", "custom"];

export { defaultFillStyle, defaultLineStyle, defaultSpotProps, defaultTooltipStyle, refLineTypes };
//# sourceMappingURL=constant.js.map
